import { useState } from 'react';
import { useDispatch } from 'react-redux';
import UserApi from '../../../../../API/user/user-api';
import { PopUp, Row } from '../../../../../components/Basic/Blocks';
import { Button } from '../../../../../components/Basic/Buttons';
import { Input, TextArea } from '../../../../../components/Basic/Inputs';
import { H2, Text, TextGrey } from '../../../../../components/Basic/WrapsStyle';
import { TYPE_BUTTONS } from '../../../../../constans';
import styles from './styles.module.scss';

const DisputeAnswerPenaltyPopUp = ({ user = {}, penalty = {}, close = () => { } }) => {
  const dispatch = useDispatch();
  const [comment, setComment] = useState('');
  const [sum, setSum] = useState(penalty.sum);

  let onClickOk = () => {
    console.log(penalty);
    UserApi.changePenalty({
      data: {
        penaltyId: penalty._id,
        field: 'protest_response',
        value: { is_annuled: true, return_sum: parseInt(sum), return_sum_desc: comment },
      }
    }).then((r) => close());
  };

  let onClickСancel = () => {
    console.log(penalty);
    UserApi.changePenalty({
      data: {
        penaltyId: penalty._id,
        field: 'protest_response',
        value: { is_annuled: false, return_sum_desc: comment },
      }
    }).then((r) => close());
  };

  return (
    <PopUp close={close} clickOutside={false} className={styles.pop_up}>
      <H2>Оспорить штраф</H2>

      <Row style={{ marginTop: '15px' }}>
        <TextGrey>Комментарий сотрудника склада: </TextGrey>
        <Text fontSize={15}>{penalty.protest}</Text>
      </Row>

      <TextArea
        value={comment}
        placeholder="Ответ проверяющего"
        width="500px"
        onChange={(v) => setComment(v)}
        minRow={4}
        maxRow={6}
        style={{ marginTop: '15px' }}
      />
      <Input label={'Сумма к возврату'} value={sum} onBlur={(v) => setSum(v)} width={'200px'} />

      <Row style={{ marginTop: '30px' }}>
        <Button type={TYPE_BUTTONS.BLUE} style={{ marginRight: '20px' }} onClick={onClickOk}>
          Сторнировать
        </Button>
        <Button
          type={TYPE_BUTTONS.RED}
          style={{ marginRight: '20px' }}
          onClick={onClickСancel}
          disabled={comment.length < 10}
        >
          Отклонить
        </Button>
        <Button type={TYPE_BUTTONS.GREY} onClick={close}>
          Отменить
        </Button>
      </Row>
    </PopUp>
  );
};

export default DisputeAnswerPenaltyPopUp;
